import axios from "axios";
import React from "react";
// import axios from "__mocks__/axios";

interface IProps {
    path: string;
    isLocalStreamUrl?: boolean;
    fileName?: string;
}

const PDFViewerStream = (props: IProps) => {
    const { path, isLocalStreamUrl = false, fileName } = props;
    const [url, setUrl] = React.useState("");

    React.useEffect(() => {
        if (isLocalStreamUrl) {
            setUrl(path);
        } else {
            axios({
                url: path, //your url
                method: "GET",
                responseType: "blob" // important
            }).then((response) => {
                const urlLocal = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                setUrl(urlLocal);
            });
        }
    }, [path, isLocalStreamUrl]);

    // PDF.js derives the download filename from the loaded URL. When we load via blob:
    // it becomes a generic name (e.g. download.pdf). Appending a fragment containing
    // the real name lets PDF.js pick it up without changing the fetched resource.
    const urlWithName = fileName
        ? `${url}#${encodeURIComponent(fileName)}`
        : url;
    let src = `/pdfjs/web/viewer.html?file=${encodeURIComponent(urlWithName)}`;

    if (url) {
        return (
            <iframe title="filePreview" src={src} width="100%" height="700px">
                This is an embedded{" "}
            </iframe>
        );
    } else {
        return null;
    }
};

export default PDFViewerStream;
